import { Component, OnDestroy, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import * as applicationConstants from '../../constants/application-constants';
import * as fromApp from '../../store/app.reducers';
import * as LayoutActions from '../../store/layout/layout.actions';
import { environment } from '@env/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {

    applicationConstants: any;
    links: any;
    query = '';
    sidebarVisible: boolean;
    subscription: Subscription;
    disableHomeLink: boolean;

    constructor(private store: Store<fromApp.AppState>) {
    }

    ngOnInit() {

        this.disableHomeLink = !!environment['disableHeaderHomeLink'];

        this.subscription = this.store.select('layout')
            .subscribe((componentsState) => {
                this.sidebarVisible = componentsState.sidebarVisible;
            });
        this.applicationConstants = applicationConstants.ApplicationConstants;

        // @ts-ignore
        const hiddenLinks = environment.hiddenTopLinks || [];

        this.links = this.applicationConstants.headerTopLinks.filter(
            link =>  hiddenLinks.indexOf(link.name) === -1);

    }

    onEnter() {
        window.location.href = this.applicationConstants.OFFICIAL_PAGE + '/' + this.query;
    }

    toggleSideBar() {
        this.store.dispatch(new LayoutActions.ToggleSidebarView(!this.sidebarVisible));
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
